import React from 'react';
import { Button, Space } from 'antd';
const BasePagination = (props) => {
  const {
    startNum: parStartNum,
    setStartNum,
    current,
    setCurrent,
    pageSize = 10,
    total,
    loading,
    setLoading,
    ...rests
  } = props;
  const maxPage = Math.ceil(total / pageSize) || 1;
  let startNum = parStartNum < 1 || parStartNum == undefined  ? 1 : parStartNum;
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '7.8rem',
        padding: '2rem 2.4rem 2.4rem 2.4rem',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      {/* LEFT */}
      <div>{`Showing ${current} to ${Number(
        maxPage
      )} of ${total} entries.`}</div>
      {/*  RIGHT */}
      <Space
        style={{
          // display: 'flex',
          // width: '100%',
          // minWidth: '',
          height: '3.4rem',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
        wrap={false}
      >
        <Button
          type="text"
          style={{
            background: 'rgba(75, 70, 92, 0.08)',
            borderRadius: '0.6rem',
          }}
          onClick={(e) => {
            const prevNum = startNum - 5; // 5씩 감소
            setStartNum((prev) => {
              if (prev <= 1) {
                return 1;
              }
              return prevNum; //prev - 1;
            });

            if (prevNum + 5 <= current) {
              // 이전의 첫페지
              setCurrent((prev) => prev - 5);
            }
          }}
          // 시작 페이지가  1이 아닌 경우
          disabled={!(startNum != 1)}
        >
          Previous
        </Button>
        {Array(maxPage > 5 ? 5 : maxPage)
          .fill()
          .map((item, idx) => {
            const textNum = startNum + idx;
            return (
              <Button
                key={textNum}
                type="text"
                style={{
                  fontFamily: 'Public Sans',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '1.5rem',
                  lineHeight: '2.2rem',
                  background:
                    textNum == current
                      ? `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`
                      : `rgba(75, 70, 92, 0.08)`,
                  color: textNum == current ? '#FFF' : '#000',
                }}
                onClick={(e) => {
                  setCurrent(textNum);
                }}
              >
                {textNum}
              </Button>
            );
          })}
        <Button
          type="text"
          style={{
            background: 'rgba(75, 70, 92, 0.08)',
            borderRadius: '0.6rem',
          }}
          onClick={(e) => {
            const baseNum = maxPage - 5;
            const nextNum = startNum + 5; //5씩 증가
            setStartNum((prev) => {
              if (prev > baseNum) {
                return maxPage;
              }
              return nextNum; //prev + 1;
            });

            if (nextNum > current) {
              // 다음 마지막 페이지  가져오기
              setCurrent((prev) => prev + 5);
            }
          }}
          // 51개부터 Next 나오도록함
          disabled={maxPage - 5 < startNum}
        >
          Next
        </Button>
        {/* 
        <Button
          onClick={(e) => {
            setLoading((prev) => !prev);
          }}
        >
          loding test
        </Button>
         */}
      </Space>
    </div>
  );
};

export default BasePagination;
